/* eslint-disable import/no-anonymous-default-export */
import rating from '../images/small-proj/rating.jpg'
import sunnyside from '../images/small-proj/sunnyside.jpg'
import musicPlayer from '../images/small-proj/music-player.png'
import robofriends from '../images/small-proj/robofriends.jpg'

export default [
    {
        id: 1,
        name: "Sunnyside Landing Page",
        img: sunnyside,
        description: "Sunnyside landing page is part of a challenge I have taken from Frontend Mentor that I have coded with the help of HTML, CSS and a few vanilla JS for the mobile navigation toggle.",
        github: "https://github.com/sayjess/sunnyside-agency-landing-page-main",
        view: "https://sayjess.github.io/sunnyside-agency-landing-page-main/",
    },
    {
        id: 2,
        name: "Shopping List",
        img: "https://store-images.s-microsoft.com/image/apps.44371.13666304476033749.c460fe0e-c4e9-44c5-84b7-b6f879b0e450.de5ecc24-e13b-4cfe-aa43-f2b4465122fe",
        description: "A simple shopping list website that uses DOM Manipulation and Event Listeners to add and/or remove items from the list.",
        github: "https://github.com/sayjess/shoplist.github.io",
        view: "https://sayjess.github.io/shoplist.github.io/",
    },
    {
        id: 3,
        name: "Linear Background Generator",
        img: "https://cssgradient.io/images/css-gradient-swatches-80de4710.svg",
        description: "A linear background color generator that you can use to either using your preffered color combination or let your computer decide ramdomly. The RGBA code is produced along with it that you can directly paste into your CSS.",
        github: "https://github.com/sayjess/lineargradientbackgroundcolorgenerator.github.io",
        view: "https://sayjess.github.io/lineargradientbackgroundcolorgenerator.github.io/",
    },
    {
        id: 4,
        name: "Robofriends",
        img: robofriends,
        description: "Robofriends uses React.js reusability to produce the card component which holds data that was fetched from an API. It uses some search technique to filter out displayed data.",
        github: "https://github.com/sayjess/robofriends",
        view: "https://robofriendsbyjess.netlify.app/",
    },
    {
        id: 5,
        name: "Interactive Rating Component",
        img: rating,
        description: "A nice, small project to practice handling user interactions and updating the DOM which is part of Frontend Mentor Challenge.",
        github: "https://github.com/sayjess/interactive-rating-component",
        view: "https://sayjess.github.io/interactive-rating-component/",
    },
    {
        id: 6,
        name: "Music Player",
        img: musicPlayer,
        description: "Made mainly using vanilla Javascript. This music player allows you to play/pause song. Or play the previous/next song available in the playlist.",
        github: "https://github.com/sayjess/music-player",
        view: "https://sayjess.github.io/music-player/",
    },
   
]